<template>

  <div>
    <div class="d-none" ref="mixins">
      <slot>

      </slot>
    </div>
    <div :class="(!isMobile && mainPicture && showPicture)?'d-flex flex-row active':'active'"
         v-if="!formConfig.hasTabs">
      <EntityEditForm ref="list"
                      :masterEntityInstance="masterEntityInstance"
                      :formConfig="formConfig"
                      :entityId="entityIdData"
                      :mode="modeData"
                      @entity-instance-loaded="setInstance"
                      @cancel="cancel"
                      @saved="saved"
                      @markReadyToShow="readyToShow = true"

                      :detailsConfig="detailsConfig"
                      :masterFormConfig="masterFormConfig"
                      :masterId="masterIdData"
                      :temporaryListToAdd="temporaryListToAdd"
                      :temporaryI`nstanceToEdit="temporaryInstanceToEdit"
                      :presetFields="presetFields"
                      :context="context"

                      @form-update="formUpdate"
                      @form-created="masterFormCreated"
                      @show-product-picture="showProductPicture"
                      :style="(mainPicture && !isMobile && showPicture)?'width:70%;':''"
                      :show-header="showHeader"
                      :show-footer="true"
                      :custom-style-for-fluid-container="customStyleForFluidContainer"
                      :show-footer-navbar="showFooterNavbar"
                      :disable-close="disableClose"
                      :inlineDetails="inlines"
                      :show-delete="showDelete"
                      :showStickyNote="mode === 'EDIT'"
                      :toolbox-mixins="toolboxMixins"
      ></EntityEditForm>
      <div v-if="mainPicture && !isMobile && showPicture" class="d-flex flex-column align-items-center"
           style="width: 30%; background: linear-gradient(270deg, #243C59 0%, #205873 76%) !important;">
        <div class="d-flex p-2 align-items-center" style="width: 100%;">
          <div style="background-color:#f2f7f5; border-radius: 0.25rem;">
            <b-btn data-test-path="header-gallery-button" @click="openListOfImages" variant="plm-toolbar-secondary"
                   style="width: 42px; ">
              <font-awesome-icon icon="arrows-rotate"/>
            </b-btn>
          </div>
          <div class="ml-auto" style="background-color:#f2f7f5; border-radius: 0.25rem;">
            <b-btn data-test-path="header-gallery-button" @click="showProductPicture"
                   variant="plm-toolbar-secondary"
                   style="width: 42px; ">
              <font-awesome-icon icon="x"/>
            </b-btn>
          </div>
        </div>
        <div class="d-flex justify-content-center m-1 flex-grow-1">
          <img :src="mainPicture.url"
               :alt="$tr('imageOfActualProduct','Image of actual product')"
               class="align-self-center responsive-image"
               ref="image">
        </div>
      </div>
    </div>
    <b-tabs ref="tabsContainer" content-class="mt-0" v-model="tabId" @input="tabChanges" @changed="tabListChanged"
            v-else>
      <b-tab title-link-class="pr-0" active @click="clickOnInfo" ref="infoTab" :data-tab-id="-1">
        <template #title>
          {{ basicInfoLabel ? basicInfoLabel : 'Info' }}

          <tab-icon v-if="masterForm && masterForm.initialized && infoOn" :status="((basicDataChanged || !basicReadOnly) && formValid) ? 'EDITED' :
                             (!formValid) ? 'ERROR' : ''"></tab-icon>
        </template>
        <div :class="(!isMobile && mainPicture && showPicture)?'d-flex flex-row':''">
          <EntityEditForm ref="basics"
                          :masterEntityInstance="masterEntityInstance"
                          :formConfig="formConfig"
                          :entityId="entityIdData"
                          :mode="modeData"
                          @entity-instance-loaded="setInstance"
                          @cancel="cancel"
                          @saved="saved"
                          @unsaved-changes="newFailed"
                          @markReadyToShow="readyToShow = true"

                          :style="(mainPicture && !isMobile && showPicture)?'width:70%;':''"
                          :custom-style-for-fluid-container="customStyleForFluidContainer"
                          :detailsConfig="detailsConfig"
                          :masterFormConfig="masterFormConfig"
                          :masterId="masterIdData"
                          :temporaryListToAdd="temporaryListToAdd"
                          :temporaryInstanceToEdit="temporaryInstanceToEdit"
                          :presetFields="presetFields"
                          :context="context"
                          :isEntityInstance="entityInstance"

                          @form-update="formUpdate"
                          @read-only-mode-change="readOnlyModeChange"
                          @form-created="masterFormCreated"
                          @show-product-picture="showProductPicture"

                          :inlineDetails="inlines"
                          :show-delete="showDelete"
                          :showStickyNote="mode === 'EDIT'"
                          :show-header="showHeader"
                          :show-footer="false"
                          :show-footer-navbar="showFooterNavbar"
                          :disable-close="disableClose"
          ></EntityEditForm>
          <div v-if="mainPicture && !isMobile && showPicture" class="d-flex  flex-column align-items-center"
               style="width: 30%; background: linear-gradient(270deg, #243C59 0%, #205873 76%) !important;">
            <div class="d-flex p-2 align-items-center" style="width: 100%;">
              <div style="background-color:#f2f7f5; border-radius: 0.25rem;">
                <b-btn data-test-path="header-gallery-button" @click="openListOfImages" variant="plm-toolbar-secondary"
                       style="width: 42px; ">
                  <font-awesome-icon icon="arrows-rotate"/>
                </b-btn>
              </div>
              <div class="ml-auto" style="background-color:#f2f7f5; border-radius: 0.25rem;">
                <b-btn data-test-path="header-gallery-button" @click="showProductPicture"
                       variant="plm-toolbar-secondary"
                       style="width: 42px; ">
                  <font-awesome-icon icon="x"/>
                </b-btn>
              </div>
            </div>
            <div class="d-flex justify-content-center m-1 flex-grow-1">
              <img :src="mainPicture.url"
                   :alt="$tr('imageOfActualProduct','Image of actual product')"
                   class="align-self-center responsive-image"
                   ref="image">
            </div>
          </div>
        </div>
      </b-tab>

      <slot name="custom-details"></slot>
      <b-tab v-for="tab in tabs" :key="tab.id" :disabled="!tab.show || !tab.visible || tab.waitForSave" :active="false"
             :data-h-visible="tab.hierarchyVisible"
             :data-h-master-tab="tab.masterTab"
             :title-link-class="tab.visible  && tab.hierarchyVisible && visibilityChecked ? '': 'd-none'"
             :data-tab-id="tab.id"
      >

        <template #title>
          <!-- w style poniżej można ustawić dodatkowe wyróżnienie dla tabek które się chowają -->
          <div v-if="tab.visible && visibilityChecked && tab.hierarchyVisible" @click="tabClick(tab)"
               :data-h-visible="tab.hierarchyVisible"
               :data-h-master-tab="tab.masterTab"
               :style="tab.hierarchyLevel == 1 ? 'font-weight:bold; color:green' :''"
          >
              <span
                  v-if="tab.isDetail"
                  v-text="
                  (tab.detail.config.detailsViewClass ? tab.detail.viewConfig.entityPlural :
                    tab.detail.config.tabTitle ? tab.detail.config.tabTitle :
                      tab.detail.config.formConfig.entityPlural)"
              >
              </span>
            <tab-icon v-if="tab.isDetail" :tab="tab" :status="tab.detail.status" :entityId="entityId" ></tab-icon>

            <span v-if="tab.isExtension && tab.show"
                  :data-test-path="tab.detail ? (tab.detail.config.formConfig.formClassLong + '-tab') :
                  (tab.extension.config.formConfig.formClassLong + '-tab')"
                  v-text="tab.extension.config.tabTitle ? tab.extension.config.tabTitle: tab.extension.config.formConfig.entityName">
            </span>
            <tab-icon v-if="tab.isExtension && tab.show" :status="((tab.extension.dataChanged || !tab.extension.readOnly) && tab.extension.formValid) ? 'EDITED' :
                               (!tab.extension.formValid) ? 'ERROR' : ''"></tab-icon>
            <font-awesome-icon v-if="tab.children && tab.children.length && !tab.open"
                               icon="circle-chevron-down" class="text-success"/>
            <font-awesome-icon v-if="tab.children && tab.children.length && tab.open"
                               icon="circle-chevron-right" style="font-weight:bold; color:green" class="text-success"/>


          </div>
        </template>
        <div :class="(!isMobile && mainPicture && showPicture)?'d-flex flex-row':''">

          <details-list v-if="tab.isDetail && masterForm && masterForm.initialized && !tab.isCustom && !tab.waitForSave"
                        :masterFormConfig="formConfig"
                        :has-write-access-to-master="hasWriteAccessToMaster"
                        :detailsConfig="tab.detail.config"
                        :masterId="entityIdData"
                        :mode="modeData"
                        @markReadyToShow="readyToShow = true"
                        :selectionSize.sync="selectionSize"
                        :reloadDataForDynamicTab.sync="reloadDataForDynamicTab"
                        :editMultiSelectFromTab.sync="showMultiSelect"
                        :showMultiSelect.sync="showMultiSelect"
                        :tabName.sync="tabName"
                        :extendedEntityEditContainer="extendedEntityEditContainer"
                        :style="(mainPicture && !isMobile && showPicture)?'width:70%;':''"
                        :ref="(tab.detail.config.detailsViewClass ? tab.detail.config.detailsViewClass : tab.detail.config.detailsClass)
                            + ':' + tab.detail.config.joiningField"
                        @cancel="cancel"
                        :temporaryList="tab.detail.temporaryList"
                        :other-changes-to-save="basicDataChanged"
                        :show-footer="false"
                        :show-footer-navbar="showFooterNavbar"
                        :disable-close="disableClose"
                        :is-detail="tab.isDetail"
                        :show-data="tab.open"
          >
          </details-list>

          <customized-details-list
              v-if="tab.isDetail && masterForm && masterForm.initialized && tab.isCustom && !tab.waitForSave"
              :masterFormConfig="formConfig"
              :has-write-access-to-master="hasWriteAccessToMaster"
              :detailsConfig="tab.detail.config"
              :masterId="entityIdData"
              :selectionSize.sync="selectionSize"
              :showMultiSelect.sync="showMultiSelect"
              :tabName.sync="tabName"
              :tempEditMultiSelectFromTab="showMultiSelect"
              @markReadyToShow="readyToShow = true"
              :mode="modeData"
              :style="(mainPicture && !isMobile && showPicture)?'width:70%;':''"
              :ref="(tab.detail.config.detailsViewClass ? tab.detail.config.detailsViewClass : tab.detail.config.detailsClass)
                            + ':' + tab.detail.config.joiningField"
              @cancel="cancel"
              :temporaryList="tab.detail.temporaryList"
              :other-changes-to-save="basicDataChanged"
              :show-footer="false"
              :show-footer-navbar="showFooterNavbar"
              :disable-close="disableClose"
          >
          </customized-details-list>
          <EntityEditForm v-if="tab.isExtension"
                          :masterEntityInstance="masterEntityInstance"

                          :ref="'ext_' + tab.extension.extensionId"

                          :extensionId="tab.extension.extensionId"
                          :formConfig="tab.extension.config.formConfig"
                          :masterFormConfig="formConfig"
                          :temporary-extension-to-set="tab.extension.temporaryExtension"
                          :temporaryInstanceToEdit="temporaryInstanceToEdit"
                          :extension-config="tab.extension.config"

                          :extensionBaseEntityId="entityIdData"
                          :master-id="masterIdData"
                          :master-form-model="masterForm"
                          :direct-parent-form-model="masterForm"
                          :reloadDataForDynamicTab.sync="reloadDataForDynamicTab"

                          :style="(mainPicture && !isMobile && showPicture)?'width:70%;':''"
                          :custom-style-for-fluid-container="customStyleForFluidContainer"
                          :presetFields="presetFields"

                          :mode="modeData"
                          @markReadyToShow="readyToShow = true"
                          @cancel="cancel"
                          @saved="saved"
                          @ready="tab.extension.waitFoSetup = false"

                          @unsaved-changes="newFailed"
                          :context="context"
                          :isEntityInstance="entityInstance"

                          @form-update="extendedFormUpdate"
                          @read-only-mode-change="extendedFormReadOnlyModeChange(tab.extension)"
                          @can-submit-change="extendedFormCanSubmitChange"
                          @form-created="extendedFormCreated"
                          @show-product-picture="showProductPicture"

                          :showDelete="false"
                          :show-header="showHeader"
                          :show-footer="false"
                          :show-footer-navbar="showFooterNavbar"
                          :disable-close="disableClose"
                          :inline-details="tab.extension.inlines"
          ></EntityEditForm>
          <div v-if="mainPicture && !isMobile && showPicture" class="d-flex flex-column align-items-center"
               style="width: 30%; background: linear-gradient(270deg, #243C59 0%, #205873 76%) !important;">
            <div class="d-flex p-2 align-items-center" style="width: 100%;">
              <div style="background-color:#f2f7f5; border-radius: 0.25rem;">
                <b-btn data-test-path="header-gallery-button" @click="openListOfImages" variant="plm-toolbar-secondary"
                       style="width: 42px; ">
                  <font-awesome-icon icon="arrows-rotate"/>
                </b-btn>
              </div>
              <div class="ml-auto" style="background-color:#f2f7f5; border-radius: 0.25rem;">
                <b-btn data-test-path="header-gallery-button" @click="showProductPicture"
                       variant="plm-toolbar-secondary"
                       style="width: 42px; ">
                  <font-awesome-icon icon="x"/>
                </b-btn>
              </div>
            </div>
            <div class="d-flex justify-content-center m-1 flex-grow-1">
              <img :src="mainPicture.url"
                   alt="Image of actual product"
                   class="align-self-center responsive-image"
                   ref="image">
            </div>
          </div>
        </div>
      </b-tab>

    </b-tabs>
    <FooterNavbar :data-test-path="'entity-edit-form-footer-' + formConfig.formId"
                  v-if="formConfig.hasTabs && showFooterNavbar && readyToShow">
      <template v-slot:info>
        <small v-if="instance && isDev" style="font-size: 8px; z-index: 10000">{{ instance.id }}</small>
        <div v-if="selectionSize && showMultiSelect" style="padding-top: 0; width: 100px; text-align: left">
          &#9745; {{ selectionSize }}
        </div>
        <div v-if="anyFormPendingTranslation" style="padding-top:6px; width: 100px; text-align: left">
          <font-awesome-icon icon="globe" transform="shrink-0 left-0" class="fa-beat"/>
        </div>
      </template>
      <CloseButton :disabled="saveInProgress || disableClose" @close="cancel" :read-only="!!readOnlyMode"></CloseButton>

      <FooterButton
          v-if="!readOnlyMode && (!formConfig.restrictedWrite || permissions[formConfig.effectivePermissionWrite])"
          type="Save"
          :disabled="!masterForm || !masterForm.canSubmit || readOnlyMode || anyFormHasErrors || anyFormCantSubmit || saveInProgress"
          @save="saveAllAndClose"
          data-test-path="save-and-close-button"
          :long-size="true"
          :label=" modeData === 'NEW' ? (partiallySavedNew ? RETRY_ADD_AND_CLOSE_LABEL: ADD_AND_CLOSE_LABEL) : SAVE_AND_CLOSE_LABEL"
      >
        <template v-slot:icon>
          <font-awesome-layers>
            <!--            <font-awesome-icon icon="caret-left" transform="shrink-0 left-7" />-->
            <font-awesome-icon icon="save" transform="shrink-0 down-0"/>
          </font-awesome-layers>
        </template>
      </FooterButton>

    </FooterNavbar>
  </div>
</template>

<script>
import Popup from "@/components/dashboard/Popup.vue";
import EntityEditForm from "@/components/forms/EntityEditForm"
import DetailsList from "@/components/forms/DetailsList";
import FormDetailsConfig from "@/server/com/silkplm/engine/forms/schema/definition/FormDetailsConfig";
import TemporaryList from "@/components/forms/TemporaryList"
import FooterNavbar from "@/components/navbar/FooterNavbar";
import FormHeader from "@/components/forms/FormHeader";
import CloseButton from "@/components/navbar/CloseButton";
import FooterButton from "@/components/navbar/FooterButton";
import TextPillsList from "@/components/inputs/controls/TextPillsList";
import ReachInput from "@/components/inputs/ReachInput";
import PermissionsSet from "@/server/PermissionsSet";
import TabIcon from "@/components/layout/TabIcon";
import TemporaryExtension from "@/components/forms/TemporaryExtension";
import Loading from "@/components/layout/Loading";
import BaseFormConfig from "@/server/com/silkplm/engine/forms/schema/BaseFormConfig";
import DialogManager from "@/utils/DialogManager";
import RtModule from "@/utils/RtModule";
import CustomizedDetailsList from "@/components/forms/CustomizedDetailsList";
import FormsActions from "@/components/forms/FormsActions";
import {
  checkIfEnabledByFeatureFlags,
  checkIfEnabledByOrganizationFormsSettingsForForm, findFieldValueFromCompanyCompanyConfigurationForm
} from "@/components/forms/customizations/plm/EntityEditFormService";
import FormModel from "@/components/forms/FormModel";
import EntitiesList from "@/components/forms/EntitiesList.vue";
import DataGrid2 from "@/components/datagrid/DataGrid2.vue";
import {isPromise} from "@/utils/Objects";
import Vue from "vue";
import SessionManager, {SILKPLM_FREE} from "@/utils/SessionManager";
import ChatMessageBase from "@/server/com/silkplm/model/plm/chat/ChatMessageBase";
import InquiryTabCore from "@/server/com/silkplm/model/plm/tabInquiry/InquiryTabCore";
import RoutingKeys from "@/server/RoutingKeys";
import PlanningProduct from "@/server/com/silkplm/model/plm/PlanningProduct";
import PPSamplesProduct from "@/server/com/silkplm/model/plm/PPSamplesProduct";
import FormsAI from "@/components/forms/FormsAI";
import FeatureFlag from "@/server/com/silkplm/rpc/FeatureFlag";
import CompanyConfigurationFunctionalFlag from "@/server/com/silkplm/model/users/CompanyConfigurationFunctionalFlag";
import CompanyConfigurationsFormsLoader from "@/components/forms/CompanyConfigurationFormsLoader";
import Rpc from "@/Rpc";
import ChatMessageInquiry from "@/server/com/silkplm/model/plm/chat/ChatMessageInquiry";
import ProductInquiry from "@/server/com/silkplm/model/plm/ProductInquiry";
import PPSampleInquiry from "@/server/com/silkplm/model/plm/PPSampleInquiry";
import EventBus from "@/utils/EventBus";
import Events from "@/utils/Events";
import DashletsRpc from "@/DashletsRpc";


let idPool = 0;
export default {
  name: "ExtendedEntityEdit",
  components: {
    DataGrid2,
    Popup,
    EntitiesList,
    CustomizedDetailsList,
    Loading,
    TabIcon,
    FooterNavbar, DetailsList, EntityEditForm, FormHeader, CloseButton, FooterButton, TextPillsList, ReachInput
  },
  created() {
    if (window['_mem_bombs']) {

      this.bomb = new ArrayBuffer(90 * 1024 * 1024);
      console.log("Bomb!!!!");
    }
    this.allTabs = [];
    this.tabByNames = {};
    this.tabsHierarchyReady = false;

  },
  async mounted() {
    this.basicInfoLabel = this.formConfig.basicInfoLabel;
    this.runtimeTrForBasicInforLabel(this.basicInfoLabel);
    // if (SessionManager.userSubscriptionType === SILKPLM_FREE) {
    //   const ComponentClass = Vue.extend(this.$options.components.Popup);
    //   if (!ComponentClass) return;
    //   const popup = new ComponentClass({
    //     parent: this,
    //   });
    //   const container = document.createElement('div');
    //   document.body.appendChild(container);
    //   popup.$mount(container);
    //   this.popupContainer = container;
    // }
    // console.log('FORM ID: ', this.formConfig.formId);
    setTimeout(async () => {
      this.infoOn = true;
      this.masterForm = await this.getMasterForm();
      if (!this.formConfig.hasTabs) {
        this.$refs.list.insertMixins(this.$refs.mixins, 'basics-data');
      } else {
        // multitab
        this.$refs.basics.insertMixins(this.$refs.mixins, 'basic-data');
        this.masterForm?.onChangePreValidate(() => {
          this.checkTabsVisibility();
        });
        this.masterForm?.afterSave(async () => {
          await this.loadEntityInstance();
          await this.checkTabsVisibility();
        })
        setTimeout(() => {
          this.checkTabsVisibility();
        });
      }

      if (this.modeData === "NEW") {
        this.hasWriteAccessToMaster = true;
        this.prepareTabsForNew();
      } else {
        if (this.masterForm.originalSource) {
          this.hasWriteAccessToMaster = this.masterForm.canEdit();
        } else {
          this.masterForm.onLoaded(() => {
            this.hasWriteAccessToMaster = this.masterForm.canEdit();
          });
        }

        this.prepareTabsForEdit();
      }

      let tabs = [];
      let inlines = [];

      for (const detail of this.details) {
        if (detail.config.visibleFunction) {
          let extensions = this.masterForm.getExtensionsObjectsForExpression();
          if (!this.entityInstance) {
            await this.loadEntityInstance();
          }
          let isVisible = await RtModule()[detail.config.visibleFunction].call(this.entityInstance, this.entityInstance,
              this.masterForm.formConfig, this.masterForm.formConfig, this.masterForm.formConfig, extensions);
          if (!isVisible && detail.config.style === "Inline") {
            continue;
          }
        }

        let detailItem = {
          masterTab: detail.config.masterTab,
          hierarchyVisible: (!detail.config.masterTab || detail.config.masterTab === 'info'),
          hierarchyLevel: (!detail.config.masterTab || detail.config.masterTab === 'info') ? 0 : 1,
          isDetail: true,
          visible: !detail.visibleFunction,
          detail,
          show: detail.show,
          order: detail.config.order,
          isCustom: false,
          waitForSave: this.modeData === "NEW"
        };
        if (this.isDisabledBySettingOrFlag(detailItem)) {
          detailItem.visible = false;
        }

        if (detail.config.style === "Tab") {
          if (FormsLoader.getCustomListEditor(detail.config.detailsViewClass ?? detail.config.detailsClass)) {
            detailItem.isCustom = true;
          }
          tabs.push(detailItem)
        } else {
          detailItem.masterFormConfig = this.formConfig;
          detailItem.masterId = this.entityIdData;

          inlines.push(detailItem)
        }
      }

      for (const extension of this.extensions) {
        let enabledFormBySettings = checkIfEnabledByOrganizationFormsSettingsForForm(extension.config.formConfig.formId);
        if (!enabledFormBySettings) {
          continue;
        }
        let visible = true;
        if (this.mode === "NEW" && !extension.config.showInAdd) {
          visible = false;
        } else if (extension.config.visibleFunction) {
          let extensions = this.masterForm.getExtensionsObjectsForExpression();
          if (!this.entityInstance) {
            await this.loadEntityInstance();
          }
          let isVisible = null;
          let visibleCheck = RtModule()[extension.config.visibleFunction].call(this.entityInstance, this.entityInstance,
              this.masterForm.formConfig, this.masterForm.formConfig, this.masterForm.formConfig, extensions);
          if (isPromise(visibleCheck)) {
            visibleCheck.then(visibility => {
              isVisible = visibility;
            });
          } else {
            isVisible = visibleCheck;
          }
        }

        let extItem = {
          masterTab: extension.config.masterTab,
          hierarchyVisible: (!extension.config.masterTab || extension.config.masterTab === 'info'),
          hierarchyLevel: (!extension.config.masterTab || extension.config.masterTab === 'info') ? 0 : 1,
          isExtension: true,
          visible: !extension.visibleFunction,
          extension,
          show: visible,
          order: extension.config.order
        };
        if (this.isDisabledBySettingOrFlag(extItem)) {
          extItem.visible = false;
        }

        tabs.push(extItem)
      }

      tabs.sort((a, b) => a.order - b.order);
      inlines.sort((a, b) => a.order - b.order);
      tabs.forEach(t => t.id = idPool++);

      for (let tab of tabs) {
        let alternativeMenuLabel = tab.detail && tab.detail.config ? findFieldValueFromCompanyCompanyConfigurationForm(tab.detail.config.formConfig.formId, "alternativeMenuLabel") : null;
        if (alternativeMenuLabel !== null) {
          tab.detail.config.tabTitle = alternativeMenuLabel;
        }

      }

      this.tabs = tabs;
      this.buildTabsHierarchy();
      this.inlines = inlines;

      this.tabChanges(0);
      let activity = null;
      let ctr = 100;

      let handlerSetup = () => {
        activity = ActivityManager.findActivity(this.$el);
        if (activity) {
          activity.onShowCallback(() => {
            this.masterForm.refreshComputedValidatedFields(true);
          });
        } else {
          ctr--;
          if (ctr > 0) {
            setTimeout(() => handlerSetup());
          } else {
            Log.info("onShowCallback not setup")
          }
        }
      }
      await this.checkTabsVisibility();
      handlerSetup();
      setTimeout(() => {
        if (this.$refs?.list?.activateDetails) {
          this.$refs?.list?.activateDetails();
        }
        if (this.$refs?.basics?.activateDetails) {
          this.$refs?.basics?.activateDetails();
        }
      });
    },);
    (this.entityId || this.masterId) && this.loadEntityInstance();

    window.addEventListener('resize', this.checkIsMobile);
    this.checkIsMobile();

    this.organization = await Rpc.OrganizationSetup.getSessionOrganizationInfo();
    this.userName = this.organization.name;

    if (this.formConfig.formClassLong === PlanningProduct.getRemoteClass() || this.formConfig.formClassLong === PPSamplesProduct.getRemoteClass()) {
      let applicationUser = await Rpc.Users.getSessionUserInfo();
      this.$subscribe(RoutingKeys.REFRESH_TABS + "." + applicationUser.id, async message => {
        let indexChatMessageBase = this.tabs.findIndex(
            value =>
                value?.detail?.config.detailsClass === ChatMessageBase.getRemoteClass()
        );

        let indexInquiryTabCore = this.tabs.findIndex(
            value =>
                value?.detail?.config.detailsClass === InquiryTabCore.getRemoteClass()
        );

        if (indexChatMessageBase !== -1) {
          this.$set(this.tabs[indexChatMessageBase], 'visible', true);
        }
        if (indexInquiryTabCore !== -1) {
          this.$set(this.tabs[indexInquiryTabCore], 'visible', true);
        }
      });
    }
    this.$onChange(CompanyConfigurationFunctionalFlag.getRemoteClass(), async (changeEvent) => {
      let userData = await Rpc.Session.userInfo();
      SessionManager.resetFlags(userData);
    });
    if (this.mode !== "NEW") {
      let formClass = this.formConfig.formClassLong;
      if (formClass === PlanningProduct.getRemoteClass() || formClass === PPSamplesProduct.getRemoteClass() ||
          formClass === "com.silkplm.model.plm.OfferView" || formClass === "com.silkplm.model.plm.SampleView") {

        let instant = await DashletsRpc.UnreadMessages.getInstantOfLastUpdatedMessageBase(this.entityId, formClass);
        this.messages = await Rpc.plm.services.marketPlace.services.RemoteMessageMethodMarketService.filterChatMessageBase(this.entityId, formClass);

        this.unreadMessagesCount = this.messages
            .filter(message => !this.isCurrentUser(message.userName))
            .filter(message => new Date(message.creationDate) > instant)
            .length;

        if (this.unreadMessagesCount > 0) {
          let data = {}
          data.notification = true;
          data.entityId = this.entityId;
          EventBus.$emit(Events.unreadMessagesNotifications, data);
        }

        this.$subscribe(RoutingKeys.RK_CHAT_CHANGE_OFFER_BASE_COMPANIES + "." + this.entityId, async message => {
          let messageEntity = new ChatMessageBase()
          await messageEntity.load(message.messageId);
          if(this.isCurrentUser(messageEntity.userName)){
            return
          }
          let data = {}
          data.notification = true;
          data.entityId = this.entityId;
          EventBus.$emit(Events.unreadMessagesNotifications, data);
        });
      }
      if (formClass === ProductInquiry.getRemoteClass() || formClass === PPSampleInquiry.getRemoteClass()) {

        let instant = await DashletsRpc.UnreadMessages.getInstantOfLastUpdatedMessageInquiry(this.entityId, formClass);
        this.messages = await Rpc.plm.services.marketPlace.services.RemoteMessageMethodMarketService.filterChatMessageInquiry(this.entityId, formClass);

        this.unreadMessagesCount = this.messages
            .filter(message => !this.isCurrentUser(message.userName))
            .filter(message => new Date(message.creationDate) > instant)
            .length;

        if (this.unreadMessagesCount > 0) {
          let data = {}
          data.notification = true;
          data.entityId = this.entityId;
          EventBus.$emit(Events.unreadMessagesNotifications, data);
        }

        this.$subscribe(RoutingKeys.RK_CHAT_CHANGE_OFFER_SUPPLIERS + "." + this.entityId, async message => {
          let messageEntity = new ChatMessageInquiry()
          await messageEntity.load(message.messageId);
          if(this.isCurrentUser(messageEntity.userName)){
            return
          }
          let data = {}
          data.notification = true;
          data.entityId = this.entityId;
          EventBus.$emit(Events.unreadMessagesNotifications, data);
        });
      }
    }
  },

  methods: {

    runtimeTrForBasicInforLabel(label) {
      if (label === "Info / Approval") {
        this.basicInfoLabel = $tr("extendedEntityEdit.infoApprovalLabel", "Info / Approval");
      }
    },
    buildTabsHierarchy() {
      let tabByNames = {};
      let infoTab = {type: 'inf', tabName: 'info', id: -1, children: [], masterTabRef: null};
      tabByNames['info'] = infoTab;
      this.tabByNames = tabByNames;
      this.applyCustomTabTitlesWithTr();
      for (let tab of this.tabs) {
        let ext = tab.detail ?? tab.extension;
        if (!ext) {
          continue;
        }

        if (ext.config?.tabName) {
          tabByNames[ext.config.tabName] = tab;
        }
        tab.children = [];
        tab.masterTabRef = null;
      }

      for (let tab of this.tabs) {
        let ext = tab.detail ?? tab.extension;
        if (ext.config?.masterTab) {
          tab.masterTabRef = tabByNames[ext.config?.masterTab];
          if (tab.masterTabRef) {
            tab.masterTabRef.children.push(tab);
          }
        }
      }
      this.tabsHierarchyReady = true;
    },

    isCurrentUser(userName) {
      return this.userName === userName;
    },

    tabListChanged(val, oldVal) {
      this.tabsInstances = val;
    },
    tabChanges(tabIndex) {
      setTimeout(() => {
        if (!this.tabsInstances) {
          return;
        }
        if (!this.tabsHierarchyReady) {
          this.buildTabsHierarchy();
        }
        let selectedTab = null;

        selectedTab = this.tabByNames["info"];
        let container = this.$refs['tabsContainer'];
        if (!this.tabsInstances[tabIndex]) {
          tabIndex = 0;
        }
        let id = this.tabsInstances[tabIndex].$el.dataset['tabId'];

        for (let tab of this.tabs) {
          if (tab.id == id) {
            selectedTab = tab;
            break;
          }
        }
        for (let tab of this.tabs) {
          tab.open = false;
        }
        selectedTab.open = true;

        let visibleItems = new Set();
        visibleItems.add(selectedTab.id);
        for (let c of selectedTab.children) {
          visibleItems.add(c.id);
        }
        if (selectedTab.masterTabRef) {
          selectedTab.masterTabRef.open = true;

          visibleItems.add(selectedTab.masterTabRef.id);
          for (let c of selectedTab.masterTabRef.children) {
            visibleItems.add(c.id);
          }
        }

        //console.log(`T ============================= `);
        for (let t of this.tabs) {
          let visible = false;
          if (!t.masterTabRef) {
            visible = true;
          } else {
            visible = visibleItems.has(t.id);
          }
          t.hierarchyVisible = visible;
          //console.log(`T:${(t.detail ?? t.extension).config.name} ${t.masterTabRef} ${visible}`)
        }
      });
    },
    tabClick(tab) {
      if (tab.detail) {
        this.tabName = tab.detail.config.formConfig.formClassLong;
      } else {
        this.tabName = tab.extension.config.formConfig.formClassLong;
      }
      SessionManager.userOnTabConfig.set(SessionManager.applicationUser.id, this.tabName);

      let markReadyAsShow = true;
      if (this.mode === "NEW") {
        if (tab.isDetail) {
          markReadyAsShow = false;
        }
      }
      if (markReadyAsShow) {
        if (!this.readySet.has(tab.id)) {
          this.readySet.add(tab.id);
          this.readyToShow = false;
        }
      }


      if (this.showMultiSelect) {
        this.showMultiSelect = !this.showMultiSelect;
      }

      if ((tab.extension && tab.extension.config.formConfig.reloadColumnsWhenDynamicsAreTab && !tab.open) ||
          (tab.detail && tab.detail.config.formConfig.reloadColumnsWhenDynamicsAreTab && !tab.open)) {
        this.reloadDataForDynamicTab = !this.reloadDataForDynamicTab;
      }
    },

    async openListOfImages() {
      await this.loadEntityInstance();
      if (this.entityInstance.gallery) {
        this.imagesList = this.entityInstance.gallery.imagesList;
      }
      this.resolveFromDialog = await DialogManager.listOfImagesDialog(this.imagesList, this.mainPicture);
    },

    showProductPicture() {
      this.showPicture = !this.showPicture;
      this.showPicture && this.loadMainImage();
    },

    checkIsMobile() {
      const isMobile = window.matchMedia('(max-width: 1100px)').matches;
      this.isMobile = isMobile;
    },

    async loadEntityInstance() {
      if (this.mode === "NEW") {
        return;
      }
      if (this.detailsConfig) {
        if (this.masterId && this.entityId) {
          this.entityInstance = await Rpc.Forms.getExtendedEntity(this.detailsConfig.detailsClass, this.entityId).lock();
        }
      } else {
        this.form = new FormModel(this.formConfig, this.presetFields ?? this.context?.presetFields);
        // TODO odświeżanie zakładek na watch klasach
        // this.form.afterValidation(() => this.checkTabsVisibility().then());
        if (this.entityId) {
          this.entityInstance = await this.form.loadEntity(this.entityId);
        }
      }
    },

    async loadMainImage() {
      this.mainPicture = null;
      this.imagesList = null;

      await this.loadEntityInstance();
      if (this.entityInstance && this.entityInstance.gallery && this.entityInstance.gallery.imagesList.length !== 0) {

        this.imagesList = this.entityInstance.gallery.imagesList;

        if (this.imagesList.length === 1) {
          this.mainPicture = this.imagesList[0];
        } else {
          this.imagesList.forEach(image => {
            if (image.customData && image.customData.imageTagList) {
              if (image.customData.imageTagList.find(tag => tag.name === "Main Picture")) {
                this.mainPicture = image;
              }
            }
          })
        }
      }
    },

    isDisabledBySettingOrFlag(ext) {
      const conf = ext?.detail?.config ?? ext?.extension?.config;

      let enabledFormBySettings = checkIfEnabledByOrganizationFormsSettingsForForm(conf.formConfig.formId);
      if (!enabledFormBySettings) {
        return true;
      } else {
        return !checkIfEnabledByFeatureFlags(conf.enabledByFeatureFlags);
      }
      return false;
    },
    async checkTabsVisibility() {
      if (!this.masterForm.initialized) {
        for (let ext of this.tabs) {
          const conf = ext?.detail?.config ?? ext?.extension?.config;
          if (conf.visibleFunction) {
            ext.visible = false;
          }
        }
        return;
      }

      this.masterForm.collectInputs();

      for (let ext of this.tabs) {
        if (!ext.visible) {
          continue;
        }
        ext.visible = !this.isDisabledBySettingOrFlag(ext);
      }

      let all = [];
      for (let ext of this.tabs) {
        /** @type{FormExtensionConfig} */
        const conf = ext?.detail?.config ?? ext?.extension?.config;
        if (this.isDisabledBySettingOrFlag(ext)) {
          continue;
        }

        if (conf.visibleFunction) {
          let inst = this.masterForm.originalSource;
          let extensions = this.masterForm.getExtensionsObjectsForExpression();
          extensions['$'] = {...this.masterForm.originalSource, ...extensions};

          let visibleCheck = RtModule()[conf.visibleFunction].call(this.entityInstance,
              this.entityInstance, this.masterForm.formConfig,
              this.masterForm.formConfig, this.masterForm.formConfig,
              extensions);
          if (isPromise(visibleCheck)) {
            let promise = visibleCheck.then(isVisible => {
              if (!ext.visible && isVisible && this.visibilityChecked && ext.isExtension) {
                const ref = 'ext_' + ext.extension.extensionId;
                this.$refs[ref][0]?.edit(true);
                //ext.extension.inlines = ext.extension._inlines;
              }
              ext.visible = isVisible;
            });
            all.push(promise);
          } else {
            if (!ext.visible && this.visibilityChecked && ext.isExtension) {
              const ref = 'ext_' + ext.extension.extensionId;
              this.$refs[ref][0]?.edit(true);
              //ext.extension.inlines = ext.extension._inlines;
            }
            ext.visible = visibleCheck;
          }

        } else {
          if (ext.isExtension) {
            //ext.extension.inlines = ext.extension._inlines;
          }
        }
      }
      if (all.length) {
        await Promise.all(all);
      }

      this.visibilityChecked = true;
    },

    prepareDetailForEdit(detail, details) {
      let row = {
        config: detail,
        id: idPool++,
        temporaryList: null,
        status: "",
        show: true,
      };
      if (detail.isView) {
        row.viewConfig = FormsLoader.detectFormConfig(detail.detailsViewClass);
      }
      details.push(row);
    },

    prepareExtensionForEdit(extension, extensions) {
      let extId = idPool++;
      let row = {
        show: true,
        config: extension,
        id: extId,
        extensionId: extId,
        temporaryExtension: null,
        status: "",
        formValid: true,
        readOnly: true,
        dataChanged: false
      };

      this.fillExtensionDetails(extension, row);
      extensions.push(row);
      this.extById[extId] = row;
    },

    prepareTabsForEdit() {
      let details = [];
      for (let detail of this.formConfig.details) {
        this.prepareDetailForEdit(detail, details);
      }
      this.details = details;

      let extensions = [];
      for (let extension of this.formConfig.extensions) {
        this.prepareExtensionForEdit(extension, extensions);
      }
      this.extensions = extensions;
    },

    prepareDetailForNew(detail, details) {
      if (!detail.showInAdd) {
        return;
      }
      let row = {
        config: detail,
        id: idPool++,
        show: detail.showInAdd,
        temporaryList: this.masterForm.temporaryLists[this.masterForm.makeFieldKey(detail)],
        status: this.masterForm.temporaryLists[this.masterForm.makeFieldKey(detail)].afterSaveStatus
      };
      row.temporaryList.onUpdate = () => row.status = row.temporaryList.afterSaveStatus;
      if (detail.isView) {
        row.viewConfig = FormsLoader.detectFormConfig(detail.detailsViewClass);
      }
      details.push(row);
    },

    prepareExtensionForNew(extension, extensions) {
      let extId = idPool++;
      let row = {
        config: extension,
        id: extId,
        show: extension.showInAdd,
        extensionId: extId,
        temporaryExtension: this.masterForm.temporaryExtensions[this.masterForm.makeFieldKey(extension)],
        status: this.masterForm.temporaryExtensions[this.masterForm.makeFieldKey(extension)].afterSaveStatus,
        formValid: true,
        readOnly: true,
        dataChanged: false
      };

      this.fillExtensionDetails(extension, row);
      extensions.push(row);
      this.extById[extId] = row;
    },

    prepareTabsForNew() {
      this.temporaryListsCreated = true;
      this.readOnlyMode = false;

      let details = [];
      for (let detail of this.formConfig.details) {
        this.prepareDetailForNew(detail, details)
      }
      this.details = details;

      let extensions = [];
      for (let extension of this.formConfig.extensions) {
        this.prepareExtensionForNew(extension, extensions);
      }
      this.extensions = extensions;
    },

    fillExtensionDetails(extension, extensionRow) {
      if (extension.formConfig.details?.length) {

        // detail in tabs
        let inlines = [];

        extension.formConfig.details.forEach(extDetail => {
          let detail = {
            config: extDetail,
            id: idPool++,
            temporaryList: null,
            status: "",
            show: true
          };
          let detailItem = {
            isDetail: true,
            detail,
            show: detail.show,
            order: detail.config.order
          };
          detailItem.masterFormConfig = null;
          detailItem.masterId = null;

          inlines.push(detailItem)
        });
        inlines.sort((a, b) => a.order - b.order);
        //extensionRow.inlines = null;
        extensionRow.inlines = inlines;
      } else {
        extensionRow.inlines = null;
        //extensionRow._inlines = null;
      }
    },

    async canClose() {
      this.checkTabsStatus();
      if (this.hasUnsaved && this.readOnlyMode === false) {

        // console.log('hasUnsaved: ', this.hasUnsaved);
        // console.log('readOnly', this.readOnlyMode);

        let isValid = await this.isValid();

        // console.log('isValid:', isValid);
        let action = await DialogManager.closeUnsaved(isValid);

        // console.log('action:', action);

        if (action === 'edit') {
          return false;
        }
        if (action === 'close') {
          return true;
        }
        if (action === 'save') {
          return this.saveAll();
        }
      } else {
        return true;
      }
    },
    extendedFormUpdate(extension) {
      this.checkTabsStatus()
    },
    /**
     * @param {FormModel}form
     */
    formUpdate(form) {
      this.basicDataChanged = form.unsavedChanges;
      this.formValid = form.isValid;
      this.formCanSubmit = form.canSubmit;
      this.checkTabsStatus();
    },

    /**
     * @return {FormModel}
     */
    async getMasterForm() {
      const waitForRef = (refName) => {
        return new Promise((resolve) => {
          const checkRef = setInterval(() => {
            if (this.$refs[refName]) {
              clearInterval(checkRef);
              resolve(this.$refs[refName]);
            }
          }, 100);
        });
      };

      if (this.formConfig.hasTabs) {
        if (!this.$refs.basics) {
          setTimeout(() => {
            return this.$refs.basics.getForm()
          }, 1000)
        } else {
          return this.$refs.basics.getForm();
        }
      } else {
        if (!this.$refs.list) {
          const listRef = await waitForRef('list');
          return listRef.getForm();
        } else {
          return this.$refs.list.getForm();
        }
      }
    },

    extendedFormCreated(form) {

    },
    willReopen() {
      return !!this.reopen;
    },
    activityClosed() {
      if (this.reopen) {
        this.reopen();
      }
    },
    masterFormCreated(form) {
      this.masterForm = form;
      this.$emit("form-created", form);
      form.onLoaded(() => {
        this.$emit("form-loaded", form);
      });

      this.masterFormInitialized = true;
      setTimeout(() => {
        if ((this.presetFields || this.context?.presetFields) && this.mode === "NEW") {
          this.masterForm.refreshComputedValidatedFields();
        }
      });
      this.masterForm.detailReloadCallback = (masterInstance, fieldName, validatedField, detailConf) => {
        let tabs = this.tabs;
        let inlines = this.inlines;

        let found = false;

        let ref = detailConf.detailsClass + ':' + detailConf.joiningField;

        this.masterForm.reloadDetail(masterInstance, fieldName, validatedField, detailConf);

        // for(const res in this.$refs) {
        //   if (res === ref) {
        //     const tabComponent = this.$refs[res][0];
        //     tabComponent.reloadTabDetail(masterInstance, fieldName, validatedField, detailConf).then();
        //     return;
        //   }
        // }
        //
        //
        // for(let tab of inlines){
        //   if(tab.isDetail) {
        //     let detConf = tab.detail.config;
        //     if(detailConf.joiningField === detConf?.joiningField && detailConf.detailsClass === detConf?.detailsClass){
        //       this.reloadInlineDetail(masterInstance, fieldName, validatedField, detailConf, tab);
        //       return;
        //     }
        //   }
        // }
      };
    },


    reloadInlineDetail(masterInstance, fieldName, validatedField, detailConf, tab) {

    },
    setInstance(instance) {
      this.instance = instance;
      this.$emit("entity-instance-loaded", instance);
    },
    cancel(data) {
      this.$emit('cancel', data);
    },
    saved(data) {
      this.$emit('saved', data);
    },


    async newFailed() {
      let masterForm = await this.getMasterForm();
      this.formValid = masterForm.isValid;
      this.partiallySavedNew = true;
      setTimeout(() => {
        for (let k in this.$refs) {
          if (k.indexOf(":") >= 0) {
            this.$refs[k].forEach(c => {
              c.refreshColumns()
            });
          }
        }
      });
    },

    async saveAllAndClose() {
      this.saveInProgress = true;

      try {
        if (this.customAdd) {
          return;
        }
        if (await this.saveAll()) {
          ActivityManager.disableFade();

          if (this.mode === "NEW") {
            let formConfig = this.formConfig;
            let id = this.masterForm.originalSource.id;

            this.reopen = async () => {
              setTimeout(async () => {
                    try {
                      if (id) {
                        await FormsActions.editEntity(formConfig, id);
                      } else {
                        this.masterForm.afterSave(async () => {
                          await FormsActions.editEntity(formConfig, id);
                        })
                      }
                    } finally {
                      ActivityManager.enableFade();
                    }
                  }
              )
            };
          }
          this.cancel(this.masterForm.originalSource);
          // this.modeData = "EDIT";
          // this.readOnlyMode = true;
          // this.hasUnsaved = false;
          //
          // this.entityIdData = this.masterForm.originalSource.id;
          // this.masterIdData = this.entityIdData;
          //
          // this.temporaryInstanceToEdit = null;
          //
          // if(this.formConfig.hasTabs) {
          //   this.$refs.basics.turnToEdit(this.masterIdData);
          //
          //   this.tabs.forEach(tab => {
          //     tab.waitForSave = false;
          //     tab.show = true;
          //     if(tab.extension)
          //     {
          //       tab.extension.temporaryExtension = null;
          //     }
          //   });
          //
          //   for(let ext of this.getExtForms()){
          //     ext.turnToEdit(this.masterIdData);
          //   }
          //
          // } else {
          //   this.$refs.list.turnToEdit?.(this.masterIdData);
          // }
        }
      } finally {
        this.saveInProgress = false;
      }
    },
    async saveAll() {
      if (this.formConfig.hasTabs) {
        let saved = await this.$refs.basics.save();
        if (this.modeData !== "NEW") {
          let extForms = this.getExtForms();
          if (extForms) {
            for (let c of extForms) {
              if (this.isExtFormVisible(c) && (c?.getForm()?.canEdit() ?? true)) {
                saved = (await c.save()) && saved;
              }
            }
          }
        } else {
          this.$emit("unsavedChanges", this.hasUnsaved);
        }
        this.hasUnsaved = !saved;
        return saved;
      } else {
        this.hasUnsaved = !(await this.$refs.list.save());
        return !this.hasUnsaved;
      }
    },

    clickOnInfo() {
      this.$emit('click-on-info')
      SessionManager.userOnTabConfig.set(SessionManager.applicationUser.id, this.formConfig.formClassLong?this.formConfig.formClassLong:"info");
    },

    async isValid() {
      if (this.formConfig.hasTabs) {
        await this.$refs.basics.validate();
      } else {
        await this.$refs.list.validate();
      }
      let extForms = this.getExtForms();
      if (extForms) {
        for (let c of extForms) {
          if (this.isExtFormVisible(c)) {
            await c.getForm().validate();
          }
        }
      }

      this.checkTabsStatus()
      return !this.anyFormHasErrors;
    },

    readOnlyModeChange() {
      this.checkTabsStatus();
    },

    extendedFormReadOnlyModeChange(extension) {
      this.checkTabsStatus();
    },

    extendedFormCanSubmitChange() {
      this.checkTabsStatus();
    },

    isExtFormVisible(refToForm) {
      let ext = this.extById[refToForm.extensionId];
      for (let tab of this.tabs) {
        if (tab.isExtension && tab.extension === ext && !tab.visible) {
          return false;
        }
      }
      return true;
    },

    getExtForms() {
      let resArr = [];
      for (const res in this.$refs) {
        if (res.startsWith("ext_")) {
          const c = this.$refs[res][0];
          if (c) {
            resArr.push(c);
          }
        }
      }

      return resArr;
    },

    checkTabsStatus() {
      /**
       * @type {[VueComponent]}
       */
      let basicTab = this.$refs.basics;
      if (!basicTab) {
        basicTab = this.$refs.list;
      }
      if (!basicTab || !basicTab.getForm()) {
        return;
      }

      let anyCardEditable = !basicTab.readOnlyMode;
      this.basicReadOnly = basicTab.readOnlyMode;
      let anyFormHasErrors = !this.formValid;
      let allCanChange = true;
      this.hasUnsaved = basicTab.getForm().unsavedChanges;
      // if (this.hasUnsaved) {
      //   console.log("a1");
      // }

      this.anyFormPendingTranslation = basicTab.getForm().pendingTranslations;

      let extForms = this.getExtForms();
      if (extForms) {
        extForms.forEach(c => {
          anyCardEditable = anyCardEditable || (!c.readOnlyMode);

          let ext = this.extById[c.extensionId];
          if (!this.isExtFormVisible(c)) {
            return;
          }

          ext.readOnly = c.readOnlyMode;
          ext.formValid = c.getForm().isValid;
          anyFormHasErrors = anyFormHasErrors || !ext.formValid;
          allCanChange = allCanChange && c.getForm().canSubmit;
          this.hasUnsaved = this.hasUnsaved || c.getForm().unsavedChanges;
          // if (this.hasUnsaved) {
          //   console.log("b2");
          // }
          this.anyFormPendingTranslation = this.anyFormPendingTranslation || c.getForm().pendingTranslations;
        });

        this.anyFormCantSubmit = !allCanChange;
        this.readOnlyMode = !anyCardEditable;
        this.anyFormHasErrors = anyFormHasErrors;
      }
      this.$emit("unsavedChanges", this.hasUnsaved);
    },
    applyCustomTabTitlesWithTr() {
      for (let tab of this.tabs) {
        if (tab?.detail?.config?.tabName) {
          if (tab.detail.config.tabTitle === "Samples") {
            tab.detail.config.tabTitle = $tr("extendedEntityEdit.samplesExtensionLabel", "Samples");
          }
        }
      }
    }
  },

  watch: {
    showMultiSelect: function (val) {
      this.$emit("update:showMultiSelect", this.showMultiSelect);
    },
    tabName: function (val) {
      this.$emit("update:tabName", this.tabName);
    },
    reloadDataForDynamicTab: function (val) {
      this.$emit("update:reloadDataForDynamicTab", this.reloadDataForDynamicTab);
    },
    resolveFromDialog: function () {
      this.mainPicture = this.resolveFromDialog.selectedItem;
    },
    tabId: function (val) {
      if (this.firstTabChange) {
        this.firstTabChange = false;
        return;
      }

      setTimeout(() => {
        if (val == 0) {
          return;
        }

        const tab = this.tabs[val - 1];
        if (tab?.isExtension) {
          const ref = 'ext_' + tab.extension.extensionId;
          if (this.$refs[ref][0].activateDetails) {
            this.$refs[ref][0].activateDetails();
          }
        } else {
          // is detail
          if (tab?.detail?.config) {
            const ref = tab.detail.config.detailsViewClass ? (tab.detail.config.detailsViewClass + ':' + tab.detail.config.joiningField) :
                (tab.detail.config.detailsClass + ':' + tab.detail.config.joiningField)
            if (this.$refs[ref][0]?.notifyShow) {
              this.$refs[ref][0].notifyShow?.();
            }
          }
        }
      });
    }
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkIsMobile);
    if (this.masterForm) {
      this.masterForm?.destroy();
    }
    if (this.popupContainer && document.body.contains(this.popupContainer)) {
      document.body.removeChild(this.popupContainer);
      this.popupContainer = null;
    }
  },
  model: {
    event: "unsavedChanges",
    prop: 'unsavedChanges'
  },

  props: {
    masterEntityInstance: {default: null},
    unsavedChanges: {type: Boolean, default: false},
    customAdd: {default: false},

    formConfig: {type: BaseFormConfig, default: ""},
    entityId: {type: String, default: ""},
    mode: {type: String, default: null},

    detailsConfig: {type: FormDetailsConfig, default: null},
    masterFormConfig: {type: BaseFormConfig, default: null},
    presetFields: {default: null},
    masterId: {type: String, default: null},
    customStyleForFluidContainer: {default: ""},
    temporaryExtensionToSet: {type: TemporaryExtension, default: null},
    temporaryListToAdd: {type: TemporaryList, default: null},
    temporaryInstanceToEdit: {default: null},
    context: {default: null},
    showDelete: {default: true},
    toolboxMixins: {type: Array, default: () => []},
    showFooterNavbar: {type: Boolean, default: true},
    disableClose: {type: Boolean, default: false},
    showHeader: {type: Boolean, default: true}
  },
  data: function () {
    return {
      basicInfoLabel: null,
      popupContainer: null,
      saveInProgress: false,
      hasWriteAccessToMaster: false,
      extendedEntityEditContainer: this,
      modeData: this.mode,
      entityIdData: this.entityId,
      masterIdData: this.masterId,
      infoOn: false,
      readyToShow: false,
      readySet: new Set(),
      visibilityChecked: false,
      hasUnsaved: false,
      readOnlyMode: this.mode === "EDIT",
      partiallySavedNew: false,
      basicReadOnly: false,
      anyFormHasErrors: false,
      anyFormPendingTranslation: false,
      anyFormCantSubmit: false,
      extById: {},
      firstTabChange: true,
      tabId: 0,
      SAVE_AND_CLOSE_LABEL: $tr("Save", "Save"),
      RETRY_ADD_AND_CLOSE_LABEL: $tr("RetryAdd", "Retry add"),
      ADD_AND_CLOSE_LABEL: $tr("add", "Add"),
      details: [],
      extensions: [],
      tabs: [],
      inlines: [],
      instance: null,
      basicDataChanged: false,
      formValid: true,
      formCanSubmit: true,
      /** @type {FormModel} */
      masterForm: null,
      temporaryListsCreated: false,
      masterFormInitialized: false,
      permissions: new PermissionsSet(),
      form: null,
      imagesList: null,
      mainPicture: false,
      entityInstance: null,
      windowWidth: null,
      isMobile: null,
      showPicture: false,
      resolveFromDialog: null,
      selectionSize: 0,
      showMultiSelect: false,
      tabName: "",
      organization: null,
      userName: null,
      reloadDataForDynamicTab: null,
      isDev: !SessionManager.isProd(),
    }
  },
}

</script>

<style scoped>
.responsive-image {
  height: auto;
  width: auto;
  max-width: 90%;
  max-height: 50vh;
  margin: 0 auto;
}
</style>